// Import Saga Functions
import { call, put, all, takeLatest } from "redux-saga/effects";
import {
  GET_SUPPLIER_LIST,
  GET_SUPPLIER_DETAILS,
  CREATE_SUPPLIER,
  UPDATE_SUPPLIER,
  DELETE_SUPPLIER,
  GET_SUPPLIER_RECENT_ACTIVITY,
  SEARCH_SUPPLIER_NOTE,
  CREATE_SUPPLIER_NOTE,
  DELETE_SUPPLIER_NOTE,
  SEARCH_SUPPLIER_ATTACHMENT,
  DELETE_SUPPLIER_ATTACHMENT,
  GET_SUPPLIER_BALANCE_HISTORICAL_BY_SUPPLIER,
  GET_SUPPLIER_BALANCE_HISTORICAL_AVAILABLE_DATES,
  GET_SUPPLIER_BALANCE_HISTORICAL_SPECIFIC_DATE,
  SEARCH_SUPPLIER_URL_LINK,
  GET_SUPPLIER_URL_LINK_DETAILS,
  CREATE_SUPPLIER_URL_LINK,
  UPDATE_SUPPLIER_URL_LINK,
  DELETE_SUPPLIER_URL_LINK,
  GET_SUPPLIER_URL_LINK_STATUS_LIST,
  GET_SUPPLIER_URL_LINK_TYPE_LIST,
} from "./actionType";

// Import Action
import {
  getSupplierListSuccess,
  getSupplierListFailure,
  getSupplierDetailsSuccess,
  getSupplierDetailsFailure,
  createSupplierSuccess,
  createSupplierFailure,
  updateSupplierSuccess,
  updateSupplierFailure,
  deleteSupplierSuccess,
  deleteSupplierFailure,
  getSupplierRecentActivitySuccess,
  getSupplierRecentActivityFailure,
  searchSupplierNoteSuccess,
  searchSupplierNoteFailure,
  createSupplierNoteSuccess,
  createSupplierNoteFailure,
  deleteSupplierNoteSuccess,
  deleteSupplierNoteFailure,
  searchSupplierAttachmentSuccess,
  searchSupplierAttachmentFailure,
  deleteSupplierAttachmentSuccess,
  deleteSupplierAttachmentFailure,
  getSupplierBalanceHistoricalBySupplierSuccess,
  getSupplierBalanceHistoricalBySupplierFailure,
  getSupplierBalanceHistoricalAvailableDatesSuccess,
  getSupplierBalanceHistoricalAvailableDatesFailure,
  getSupplierBalanceHistoricalSpecificDateSuccess,
  getSupplierBalanceHistoricalSpecificDateFailure,
  searchSupplierUrlLinkSuccess,
  searchSupplierUrlLinkFailure,
  getSupplierUrlLinkDetailsSuccess,
  getSupplierUrlLinkDetailsFailure,
  createSupplierUrlLinkSuccess,
  createSupplierUrlLinkFailure,
  updateSupplierUrlLinkSuccess,
  updateSupplierUrlLinkFailure,
  deleteSupplierUrlLinkSuccess,
  deleteSupplierUrlLinkFailure,
  getSupplierUrlLinkStatusListSuccess,
  getSupplierUrlLinkStatusListFailure,
  getSupplierUrlLinkTypeListSuccess,
  getSupplierUrlLinkTypeListFailure,
} from "./action";
import {
  getSupplierListApiCall,
  getSingleSupplierDetailsApiCall,
  createSingleSupplierApiCall,
  updateSingleSupplierApiCall,
  deleteSingleSupplierApiCall,
  getSupplierRecentActivityApiCall,
  searchSupplierNoteApiCall,
  createSupplierNoteApiCall,
  deleteSupplierNoteApiCall,
  searchSupplierAttachmentApiCall,
  deleteSupplierAttachmentApiCall,
  getSupplierBalanceHistoricalBySupplierApiCall,
  getSupplierBalanceHistoricalAvailableDatesApiCall,
  getSupplierBalanceHistoricalSpecificDateApiCall,
  searchSupplierUrlLinkApiCall,
  getSupplierUrlLinkDetailsApiCall,
  createSupplierUrlLinkApiCall,
  updateSupplierUrlLinkApiCall,
  deleteSupplierUrlLinkApiCall,
  getSupplierUrlLinkStatusListApiCall,
  getSupplierUrlLinkTypeListApiCall,
} from "../../helpers/fakebackend_helper";

// Import API

// Saga for supplier
function* getSupplierListSaga() {
  try {
    // Call API
    const response = yield call(getSupplierListApiCall);
    yield put(getSupplierListSuccess(response));
  } catch (error) {
    yield put(getSupplierListFailure(error));
  }
}

function* watchGetSupplierListSaga() {
  yield takeLatest(GET_SUPPLIER_LIST, getSupplierListSaga);
}

// Saga for single supplier details
function* getSingleSupplierDetailsSaga(action) {
  try {
    // Call API
    const response = yield call(
      getSingleSupplierDetailsApiCall,
      action.payload
    );
    yield put(getSupplierDetailsSuccess(response));
  } catch (error) {
    yield put(getSupplierDetailsFailure(error));
  }
}

function* watchGetSingleSupplierDetailsSaga() {
  yield takeLatest(GET_SUPPLIER_DETAILS, getSingleSupplierDetailsSaga);
}
// Saga for create single supplier
function* createSingleSupplierSaga(action) {
  try {
    // Call API
    const response = yield call(createSingleSupplierApiCall, action.payload);
    yield put(createSupplierSuccess(response));
  } catch (error) {
    yield put(createSupplierFailure(error));
  }
}

// Watcher for create single supplier
function* watchCreateSingleSupplierSaga() {
  yield takeLatest(CREATE_SUPPLIER, createSingleSupplierSaga);
}

// Saga for update single supplier
function* updateSingleSupplierSaga(action) {
  try {
    // Call API
    const response = yield call(updateSingleSupplierApiCall, action.payload);
    yield put(updateSupplierSuccess(response));
  } catch (error) {
    yield put(updateSupplierFailure(error));
  }
}
// Watcher for update single supplier
function* watchUpdateSingleSupplierSaga() {
  yield takeLatest(UPDATE_SUPPLIER, updateSingleSupplierSaga);
}

// Saga for delete single supplier
function* deleteSingleSupplierSaga(action) {
  try {
    // Call API
    const response = yield call(deleteSingleSupplierApiCall, action.payload);
    yield put(deleteSupplierSuccess(response));
  } catch (error) {
    yield put(deleteSupplierFailure(error));
  }
}

// Watcher for delete single supplier

function* watchDeleteSingleSupplierSaga() {
  yield takeLatest(DELETE_SUPPLIER, deleteSingleSupplierSaga);
}

// Saga for get supplier recent activity
function* getSupplierRecentActivitySaga(action) {
  try {
    // Call API
    const response = yield call(
      getSupplierRecentActivityApiCall,
      action.payload
    );
    yield put(getSupplierRecentActivitySuccess(response));
  } catch (error) {
    yield put(getSupplierRecentActivityFailure(error));
  }
}

// Watcher for get supplier recent activity
function* watchGetSupplierRecentActivitySaga() {
  yield takeLatest(GET_SUPPLIER_RECENT_ACTIVITY, getSupplierRecentActivitySaga);
}

// Saga for search supplier note
function* searchSupplierNoteSaga(action) {
  try {
    const response = yield call(searchSupplierNoteApiCall, action.payload);
    yield put(searchSupplierNoteSuccess(response));
  } catch (error) {
    yield put(searchSupplierNoteFailure(error));
  }
}
function* watchSearchSupplierNoteSaga() {
  yield takeLatest(SEARCH_SUPPLIER_NOTE, searchSupplierNoteSaga);
}

// Saga for create supplier note
function* createSupplierNoteSaga(action) {
  try {
    const response = yield call(createSupplierNoteApiCall, action.payload);
    yield put(createSupplierNoteSuccess(response));
  } catch (error) {
    yield put(createSupplierNoteFailure(error));
  }
}
function* watchCreateSupplierNoteSaga() {
  yield takeLatest(CREATE_SUPPLIER_NOTE, createSupplierNoteSaga);
}

// Saga for delete supplier note
function* deleteSupplierNoteSaga(action) {
  try {
    const response = yield call(deleteSupplierNoteApiCall, action.payload);
    yield put(deleteSupplierNoteSuccess(response));
  } catch (error) {
    yield put(deleteSupplierNoteFailure(error));
  }
}
function* watchDeleteSupplierNoteSaga() {
  yield takeLatest(DELETE_SUPPLIER_NOTE, deleteSupplierNoteSaga);
}

// Saga for search supplier attachment
function* searchSupplierAttachmentSaga(action) {
  try {
    const response = yield call(searchSupplierAttachmentApiCall, action.payload);
    yield put(searchSupplierAttachmentSuccess(response));
  } catch (error) {
    yield put(searchSupplierAttachmentFailure(error));
  }
}
function* watchSearchSupplierAttachmentSaga() {
  yield takeLatest(SEARCH_SUPPLIER_ATTACHMENT, searchSupplierAttachmentSaga);
}

// Saga for delete supplier attachment
function* deleteSupplierAttachmentSaga(action) {
  try {
    const response = yield call(deleteSupplierAttachmentApiCall, action.payload);
    yield put(deleteSupplierAttachmentSuccess(response));
  } catch (error) {
    yield put(deleteSupplierAttachmentFailure(error));
  }
}
function* watchDeleteSupplierAttachmentSaga() {
  yield takeLatest(DELETE_SUPPLIER_ATTACHMENT, deleteSupplierAttachmentSaga);
}

// Saga for supplier balance historical — monthly snapshots for one supplier
function* getSupplierBalanceHistoricalBySupplierSaga(action) {
  try {
    const response = yield call(
      getSupplierBalanceHistoricalBySupplierApiCall,
      action.payload
    );
    yield put(getSupplierBalanceHistoricalBySupplierSuccess(response));
  } catch (error) {
    yield put(getSupplierBalanceHistoricalBySupplierFailure(error));
  }
}
function* watchGetSupplierBalanceHistoricalBySupplierSaga() {
  yield takeLatest(
    GET_SUPPLIER_BALANCE_HISTORICAL_BY_SUPPLIER,
    getSupplierBalanceHistoricalBySupplierSaga
  );
}

// Saga for supplier balance historical — available dates
function* getSupplierBalanceHistoricalAvailableDatesSaga() {
  try {
    const response = yield call(
      getSupplierBalanceHistoricalAvailableDatesApiCall
    );
    yield put(getSupplierBalanceHistoricalAvailableDatesSuccess(response));
  } catch (error) {
    yield put(getSupplierBalanceHistoricalAvailableDatesFailure(error));
  }
}
function* watchGetSupplierBalanceHistoricalAvailableDatesSaga() {
  yield takeLatest(
    GET_SUPPLIER_BALANCE_HISTORICAL_AVAILABLE_DATES,
    getSupplierBalanceHistoricalAvailableDatesSaga
  );
}

// Saga for supplier balance historical — whole-book snapshot for one date
function* getSupplierBalanceHistoricalSpecificDateSaga(action) {
  try {
    const response = yield call(
      getSupplierBalanceHistoricalSpecificDateApiCall,
      action.payload
    );
    yield put(getSupplierBalanceHistoricalSpecificDateSuccess(response));
  } catch (error) {
    yield put(getSupplierBalanceHistoricalSpecificDateFailure(error));
  }
}
function* watchGetSupplierBalanceHistoricalSpecificDateSaga() {
  yield takeLatest(
    GET_SUPPLIER_BALANCE_HISTORICAL_SPECIFIC_DATE,
    getSupplierBalanceHistoricalSpecificDateSaga
  );
}

// Saga for supplier url links (Task 24318)
function* searchSupplierUrlLinkSaga(action) {
  try {
    const response = yield call(searchSupplierUrlLinkApiCall, action.payload);
    yield put(searchSupplierUrlLinkSuccess(response));
  } catch (error) {
    yield put(searchSupplierUrlLinkFailure(error));
  }
}
function* watchSearchSupplierUrlLinkSaga() {
  yield takeLatest(SEARCH_SUPPLIER_URL_LINK, searchSupplierUrlLinkSaga);
}

function* getSupplierUrlLinkDetailsSaga(action) {
  try {
    const response = yield call(
      getSupplierUrlLinkDetailsApiCall,
      action.payload
    );
    yield put(getSupplierUrlLinkDetailsSuccess(response));
  } catch (error) {
    yield put(getSupplierUrlLinkDetailsFailure(error));
  }
}
function* watchGetSupplierUrlLinkDetailsSaga() {
  yield takeLatest(GET_SUPPLIER_URL_LINK_DETAILS, getSupplierUrlLinkDetailsSaga);
}

function* createSupplierUrlLinkSaga(action) {
  try {
    const response = yield call(createSupplierUrlLinkApiCall, action.payload);
    yield put(createSupplierUrlLinkSuccess(response));
  } catch (error) {
    yield put(createSupplierUrlLinkFailure(error));
  }
}
function* watchCreateSupplierUrlLinkSaga() {
  yield takeLatest(CREATE_SUPPLIER_URL_LINK, createSupplierUrlLinkSaga);
}

function* updateSupplierUrlLinkSaga(action) {
  try {
    const response = yield call(updateSupplierUrlLinkApiCall, action.payload);
    yield put(updateSupplierUrlLinkSuccess(response));
  } catch (error) {
    yield put(updateSupplierUrlLinkFailure(error));
  }
}
function* watchUpdateSupplierUrlLinkSaga() {
  yield takeLatest(UPDATE_SUPPLIER_URL_LINK, updateSupplierUrlLinkSaga);
}

function* deleteSupplierUrlLinkSaga(action) {
  try {
    const response = yield call(deleteSupplierUrlLinkApiCall, action.payload);
    yield put(deleteSupplierUrlLinkSuccess(response));
  } catch (error) {
    yield put(deleteSupplierUrlLinkFailure(error));
  }
}
function* watchDeleteSupplierUrlLinkSaga() {
  yield takeLatest(DELETE_SUPPLIER_URL_LINK, deleteSupplierUrlLinkSaga);
}

function* getSupplierUrlLinkStatusListSaga() {
  try {
    const response = yield call(getSupplierUrlLinkStatusListApiCall);
    yield put(getSupplierUrlLinkStatusListSuccess(response));
  } catch (error) {
    yield put(getSupplierUrlLinkStatusListFailure(error));
  }
}
function* watchGetSupplierUrlLinkStatusListSaga() {
  yield takeLatest(
    GET_SUPPLIER_URL_LINK_STATUS_LIST,
    getSupplierUrlLinkStatusListSaga
  );
}

function* getSupplierUrlLinkTypeListSaga() {
  try {
    const response = yield call(getSupplierUrlLinkTypeListApiCall);
    yield put(getSupplierUrlLinkTypeListSuccess(response));
  } catch (error) {
    yield put(getSupplierUrlLinkTypeListFailure(error));
  }
}
function* watchGetSupplierUrlLinkTypeListSaga() {
  yield takeLatest(
    GET_SUPPLIER_URL_LINK_TYPE_LIST,
    getSupplierUrlLinkTypeListSaga
  );
}

export default function* Supplier() {
  yield all([
    watchGetSupplierListSaga(),
    watchGetSingleSupplierDetailsSaga(),
    watchCreateSingleSupplierSaga(),
    watchUpdateSingleSupplierSaga(),
    watchDeleteSingleSupplierSaga(),
    watchGetSupplierRecentActivitySaga(),
    watchSearchSupplierNoteSaga(),
    watchCreateSupplierNoteSaga(),
    watchDeleteSupplierNoteSaga(),
    watchSearchSupplierAttachmentSaga(),
    watchDeleteSupplierAttachmentSaga(),
    watchGetSupplierBalanceHistoricalBySupplierSaga(),
    watchGetSupplierBalanceHistoricalAvailableDatesSaga(),
    watchGetSupplierBalanceHistoricalSpecificDateSaga(),
    watchSearchSupplierUrlLinkSaga(),
    watchGetSupplierUrlLinkDetailsSaga(),
    watchCreateSupplierUrlLinkSaga(),
    watchUpdateSupplierUrlLinkSaga(),
    watchDeleteSupplierUrlLinkSaga(),
    watchGetSupplierUrlLinkStatusListSaga(),
    watchGetSupplierUrlLinkTypeListSaga(),
  ]);
}
